import * as React from "react"

/**
 * Below Tailwind's `md` breakpoint a docked drawer would leave the page too
 * narrow to use, so the drawer becomes a full-width modal sheet instead.
 */
const SHEET_QUERY = "(max-width: 767.98px)"

function getSnapshot() {
  return (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia(SHEET_QUERY).matches
  )
}

function getServerSnapshot() {
  return false
}

function subscribe(onChange: () => void) {
  if (
    typeof window === "undefined" ||
    typeof window.matchMedia !== "function"
  ) {
    return () => undefined
  }

  const mediaQuery = window.matchMedia(SHEET_QUERY)
  if (typeof mediaQuery.addEventListener === "function") {
    mediaQuery.addEventListener("change", onChange)
    return () => mediaQuery.removeEventListener("change", onChange)
  }

  mediaQuery.addListener(onChange)
  return () => mediaQuery.removeListener(onChange)
}

/**
 * Whether drawers present as a full-width modal sheet rather than docking
 * beside the page. Always `false` during server render.
 */
export function useDrawerSheet(): boolean {
  return React.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
